import { translateCountryCode } from 'ui-seeker/utils'
import { formatWithFlag } from 'app/utils'

export const sampleFilter = (text, filterType='textField') => ({
    filterType: filterType,
    customFilterListOptions: { render: v => `${text}: ${v}` },
})

export const sampleDropdownFilter = (text, emptyText='Any') => ({
    customFilterListOptions: { render: v => `${text}: ${v ? v : emptyText}` },
    filterOptions: {
        renderValue: v => v ? v : emptyText
    },
})

export const sampleBooleanFilter = (text, {trueText='Yes', falseText='No'}={}) => ({
    filterType: 'checkbox',
    customFilterListOptions: { render: v => `${text}: ${v ? trueText : falseText}` },
    filterOptions: {
        renderValue: v => v ? trueText : falseText
    },
})

export const countryDropdownFilter = (text='country', emptyText='Any') => ({
    customFilterListOptions: { render: v => `${text}: ${v ? translateCountryCode(v) : emptyText}` },
    filterOptions: {
        renderValue: v => v ? formatWithFlag(v, {countryName: true}) : emptyText
    },
})